import React from 'react'
import './authors.styles.scss'
import Author from './author/author.component'

const Authors = props => {
    return (
        <div className="authors">
            {
                props.authors.map((author, key) => <Author key={key} {...author}/>)
            }
        </div>
    )
}

export default Authors